import styled from 'styled-components'
import { media } from '../../../../layouts/utils'
import {
	TituloH1 as TituloPrincipal,
	Sorriso as IconSorriso
} from '../../../../components/TituloSorriso/styles'
import { fontFamily,  } from 'src/global.style';

export const Wrapper = styled.div`
  background: linear-gradient(180deg, rgba(255,81,89) 0%,  rgba(212,24,33) 90%);
  width: 100%;
  padding-bottom: 20px;
`;

export const Title = styled(TituloPrincipal)`
  padding-top: 64px;
  font-size: 48px;
  font-weight: 500;
	color: #FFFFFF;
  ${media.phone`
    padding-top: 44px;
    font-size: 28px;
  `}
`;

export const Sorriso = styled(IconSorriso)`
  margin-bottom: 0;
  filter: ${(props) => props.filter && `brightness(100)`};
`;
export const ContainerButton = styled.div`
  display:flex;
  justify-content: center;
  margin-bottom: 60px;

  ${media.phone`
			margin-bottom: 32px;
 	`}

  .botaoTagVeloe {
		min-width: unset;
		height: 52px;
		width: 140px;
		padding: 0;
		font-family: ${fontFamily.neutral};
		font-weight: bold;

			:hover{
				min-width: unset;
				height: 52px;
				width: 142px;
				padding: 0;
				margin-bottom: 0;
				margin-right: -0.5rem;
				transition: 0.2s;
				transform: translateY(-0.25rem);
			}
			
		${media.phone`
			margin-top: 15px;
 	 	`}
    & span{
      top: 0;
    }
	}
`;
